import { api } from './_client';
import type {
  ReportFilters,
  ReportFiltersResponse,
  ReportsListResponse,
  ReportGenerateResponse,
  ReportDownloadResponse,
} from '../../types/api';

export const reportsApi = {
  // Get available report filters (drones, payloads, pilots)
  async getReportFilters(): Promise<ReportFiltersResponse> {
    const response = await api.get<ReportFiltersResponse>('/api/reports/filters');
    return response.data;
  },

  // List all reports for the organization
  async listReports(): Promise<ReportsListResponse> {
    const response = await api.get<ReportsListResponse>('/api/reports');
    return response.data;
  },

  // Generate a new PDF report
  async generateReport(title: string, filters: ReportFilters): Promise<ReportGenerateResponse> {
    const response = await api.post<ReportGenerateResponse>('/api/reports', {
      title,
      filters,
    });
    return response.data;
  },

  // Get download URL for a report
  async downloadReport(reportId: string): Promise<ReportDownloadResponse> {
    const response = await api.get<ReportDownloadResponse>(`/api/reports/${reportId}/download`);
    return response.data;
  },

  // Delete a report
  async deleteReport(reportId: string): Promise<{ success: boolean; message?: string }> {
    const response = await api.delete(`/api/reports/${reportId}`);
    return response.data;
  },
};
